import React, { useState, useReducer, createContext, useContext, useEffect } from 'react';
import { Select, Button, Table, Modal, Input, DatePicker, Switch, message, Upload } from 'antd';
import "./index.less";
import { seoList, seoUploadBatch, seoUpdate, setGetDetail, setDelete, news_host } from "../../api";
import { getSelectionInlineStyle } from 'braft-utils/dist/content';
const { Option } = Select;
const { RangePicker } = DatePicker;
const Ctx = createContext();

const initInfo = {
    firstClassifyChooseId: '',
    keyWord: '',
    delStatus: '',
    url: '',
    id: null,
}
const reducer = (state, action) => {
    return { ...state, ...action };
}

const recommendStatus = ['启用', '停用'];
const timeStyle = 'YYYY-MM-DD HH:mm:ss';
//  子组件模态框
const EditModal = () => {
    const { state: { isModalVisible, info, isModify }, dispatch } = useContext(Ctx);
    const [selectSloganListData, setSelectSloganListData] = useState([])
    const [delStatus, setDelStatus] = useState(info.delStatus)
    console.log(info.delStatus)
    useEffect(() => {
        setDelStatus(info.delStatus + '')
    }, [info.delStatus])
    const handleOk = async () => {
        let res;
        if (info.searchWord == '') {
            message.error('请输入搜索词!')
            return
        }
        if (info.delStatus == null) {
            message.error('请选择是否启用!')
            return
        }
        res = await seoUpdate(info.id, info.searchWord, info.delStatus);
        if (res?.error?.errorCode == 0) {
            dispatch({ isModalVisible: false, success: true });
            message.success('修改成功!');
        } else {
            message.error(res?.error?.errorMsg);
        }
    };

    const handleCancel = () => {
        dispatch({ isModalVisible: false });
        if (isModify) {
            dispatch({
                info: {
                    ...info,
                    keyWord: '',
                    searchWord: '',
                    uploadDate: '',
                    url: '',
                    id: null,
                    delStatus: null
                }
            })
        }
    };

    // 状态修改
    const handleChangeDelStatus = value => {
        setDelStatus(value)//显示标语
        dispatch({ info: { ...info, delStatus: value } })
    };
    return (
        <Modal visible={isModalVisible} wrapClassName='classify_yunying_modal' onOk={handleOk} title={isModify ? '新增' : '编辑'} onCancel={handleCancel} footer={[
            isModify ?
                <Button key="submit" type="primary" onClick={handleOk}>
                    新增
                </Button>
                : <Button key="submit" type="primary" onClick={handleOk}>
                    修改
                </Button>, <Button key="submit" type="primary" onClick={handleCancel}>
                取消
            </Button>
        ]}>
            <>
                <div className='form_item'>
                    <span className='form_item_label'>关键词：</span>
                    <Input className='form_item_input' disabled placeholder="请输入推荐词" value={info.keyWord} onChange={e => dispatch({ info: { ...info, keyWord: e.target.value } })} />
                </div>
                <div className='form_item'>
                    <span className='form_item_label'>搜索词：</span>
                    <Input className='form_item_input' placeholder="请输入搜索词" value={info.searchWord} onChange={e => dispatch({ info: { ...info, searchWord: e.target.value } })} />
                </div>
                <div className='form_item'>
                    <span className='form_item_label'>序号：</span>
                    <Input className='form_item_input' disabled value={info.index} />
                </div>
                <div className='form_item'>
                    <span className='form_item_label'>状态：</span>
                    {/* <Input className='form_item_input' placeholder="请输入标语" value={info.delStatus} onChange={e => dispatch({ info: { ...info, slogan: e.target.value } })} /> */}
                    <Select value={delStatus} style={{ width: 372 }} onChange={handleChangeDelStatus}>
                        <Option value='0' key={0}>启用</Option>
                        <Option value='1' key={1}>停用</Option>
                    </Select>
                </div>
            </>

        </Modal>
    )
}
// 父组件 最外层
function LinkUrlManage() {
    const [delStatus, setDelStatus] = useState(null);//一级分类默认选中
    const [listLoading, setListLoading] = useState(false)
    const [secondClassifyList, setSecondClassifyList] = useState([]);
    const [keysList, setkeysList] = useState([]);
    const [keyWord, setKeyWord] = useState('');
    const [searchWord, setSearchWord] = useState('');
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(1);
    const [timer, setTimer] = useState(null);//发布时间
    const [dateArr, setDateArr] = useState([]);//时间区间
    const [state, dispatch] = useReducer(reducer, {
        isModify: true, isModalVisible: false, info: initInfo, success: false
    });
    useEffect(() => {
        geSeoList(false, 1);
    }, [])

    useEffect(() => {
        if (state.success) {
            geSeoList(false, page);
            dispatch({ success: false })
        }
    }, [state.success]);
    const columns = [
        {
            title: "序号",
            width: '8%',
            render: (text, record, index) => index + 1
        },
        {
            title: '关键词',
            dataIndex: 'keyWord',
            width: '20%'
        },
        {
            title: '搜索词',
            dataIndex: 'searchWord',
            width: '20%'
        },
        {
            title: 'URL',
            dataIndex: 'url',
            width: '12%',
        },
        {
            title: '状态',
            dataIndex: 'delStatus',
            width: '10%',
            // sorter: (a, b) => a.delStatus > b.delStatus ? 1 : -1,
            // sorter: true,
            render: (v) => {
                return (
                    <span>{recommendStatus[v]}</span>
                )
            }
        },
        {
            title: '更新时间',
            dataIndex: 'uploadDate',
            width: '12%',
        },
        {
            title: '操作',
            dataIndex: '',
            render: (v, r, index) => {
                return (
                    <>
                        <Button onClick={() => { window.open(r.url.substring(0, r.url.length - 5) + '_1.html?') }}>预览</Button>
                        {r.delStatus == 0
                            ? <Button onClick={() => updateStatus(r, 1)}>停用</Button> : <Button onClick={() => updateStatus(r, 0)}>启用</Button>}
                        <Button onClick={() => modify(r, index)}>编辑</Button>
                        <Button onClick={() => deleteData(r)}>删除</Button>
                    </>
                )
            },
        }
    ]

    const handleChangePublishTime = (value, dateArr) => {
        setTimer(value)
        let timeArr = [...dateArr];
        timeArr[0] = timeArr[0].replace(/\//g, '-')
        timeArr[1] = timeArr[1].replace(/\//g, '-')
        setDateArr(timeArr)//替换 / 为 -  重新赋值
    }
    // 编辑带入当前列表的数据填充
    const modify = (record, index) => {
        console.log(index)
        setGetDetail(record.id).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                dispatch({
                    isModalVisible: true, isModify: false,
                    info: {
                        ...state.info, keyWord: res?.data?.keyWord,
                        searchWord: res?.data?.searchWord,
                        uploadDate: res?.data?.uploadDate,
                        delStatus: res?.data?.delStatus,
                        index: index + 1,
                        id: res?.data?.id
                    }
                });
            }

        })

    }
    // 删除列表数据
    const deleteData = record => {
        setDelete(record?.id).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                message.info('已删除')
                geSeoList(false, page);
            }
        })
    }
    // 启用，停用接口
    const updateStatus = async (record, delStatus) => {
        const res = await seoUpdate(record.id, record.searchWord, delStatus);
        if (res?.error?.errorCode == 0) {
            geSeoList(false, page);
        }
    }

    // 获取拓词列表 渲染表格
    const geSeoList = (resetBol, page) => {
        setListLoading(true)

        const params = {
            delStatus: delStatus == 2 ? null : delStatus,
            page: page,
            pageSize: 50,
            keyWord: keyWord,
            searchWord: searchWord,
            startDate: dateArr[0] ? dateArr[0] : '',
            endDate: dateArr[1] ? dateArr[1] : '',
        }
        if (resetBol) {
            params.delStatus = null;
            params.keyWord = '';
            params.searchWord = '';
            params.startDate = '';
            params.endDate = '';
        }
        seoList(params).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                console.log(res)
                setkeysList(res?.data?.contents)

                setTotal(res?.data?.total)
            } else {
                setkeysList([])
            }
        }).finally(() => {
            setListLoading(false)
        })
    }

    // 一级分类change
    const handleChangeDelStatus = value => {
        setDelStatus(value);
    };
    // 查询
    const search = () => {
        setPage(1)
        geSeoList(false, 1)
    }
    // 重置
    const reset = () => {
        setTimer(null)
        setKeyWord('')
        setSearchWord('')
        setDelStatus(null)
        setPage(1)
        geSeoList(true, 1)
        setDateArr([])
    }
    // 新增
    const addNewItem = () => {

    }
    // 一键启用方法
    const doStart = () => {
        const params = {
            delStatus: delStatus == 2 ? null : delStatus,
            page: page,
            pageSize: 50,
            keyWord: keyWord,
            searchWord: searchWord,
            startDate: dateArr[0] ? dateArr[0] : '',
            endDate: dateArr[1] ? dateArr[1] : '',
        }
        seoUploadBatch(params).then((res) => {
            if (res?.error?.errorCode == 0 + '') {
                message.success('一键启用成功!')
                setPage(1)
                geSeoList(false, 1)
            } else {
                message.success('一键启用失败!')
            }
        })
    }
    const beforeUpload = (file) => {
        console.log(file);
        const name = file.name.split(".");
        if (name[name.length - 1] === "xlsx" || name[name.length - 1] === "xls") {
            message.success("开始上传！");
            return true;
        }
        message.error("请上传 excel 文件！");
        return false;
    };
    const onUploadChange = (res) => {
        if (res?.error?.errorCode == 0) {
            search();
            return message.success("上传成功！");
        } else {
            return message.error(res?.error?.errorMsg ?? "发生错误");
        }
    }
    return (
        <div className="classifyManage">
            <div className="topForm">
                <h2>拓词管理</h2>
                <div className="myForm">

                    <div>
                        <span className="select_label">关键词：</span>
                        <Input type={Number} style={{ width: 125 }} placeholder="请输入关键词" value={keyWord} onChange={(e) => {
                            setKeyWord(e.target.value)
                        }} />
                    </div>
                    <div>
                        <span className="select_label">搜索词：</span>
                        <Input type={Number} style={{ width: 125 }} placeholder="请输入搜索词" value={searchWord} onChange={(e) => {
                            setSearchWord(e.target.value)
                        }} />
                    </div>
                    <div>
                        <span className="select_label">状态：</span>
                        <Select value={delStatus} style={{ width: 120 }} onChange={handleChangeDelStatus}>
                            <Option value={2} key={2}>全部</Option>
                            <Option value={0} key={0}>启用</Option>
                            <Option value={1} key={1}>停用</Option>
                        </Select>
                    </div>
                    <div className='filterItem'>
                        <span>时间：</span>
                        <RangePicker
                            value={timer}
                            showTime={{ format: 'HH:mm:ss' }}
                            format="YYYY/MM/DD HH:mm:ss"
                            onChange={handleChangePublishTime}
                        />
                    </div>

                    <div>
                        <Button type="primary" onClick={search}>查询</Button>
                        <Button type='' onClick={reset}>重置</Button>

                        <Upload
                            action={`${news_host}/seo/import`}
                            method="post"
                            beforeUpload={beforeUpload}
                            fileList={[]}
                            onSuccess={onUploadChange}
                        >
                            <Button type="primary" onClick={addNewItem}>新增</Button>
                        </Upload>

                        <Button type="primary" onClick={doStart}>一键启用</Button>
                    </div>
                </div>

            </div>
            <div className="bottomTable">
                <Table
                    loading={listLoading}
                    columns={columns}
                    dataSource={keysList}
                    pagination={
                        {
                            total: total,
                            current: page,
                            onChange(page) {
                                setPage(page)
                                geSeoList(false, page)
                            },
                            pageSize: 50
                        }
                    }
                />
            </div>
            <Ctx.Provider value={{ state, dispatch }} >
                <EditModal isModalVisible={state.isModalVisible} />
            </Ctx.Provider>
        </div >
    )
}

export default LinkUrlManage;